import { SET_ERROR_COMPANYCUSTOMER_STATE } from './action';

import { Map } from 'immutable';

const initialState = Map({
  payload: Map({
    type: '',
    error: false,
    notStore: false,
  }),
});

function reducer(state = initialState, action): any {
  const { type } = action;

  if (type === SET_ERROR_COMPANYCUSTOMER_STATE) {
    const { payload } = action;
    return state.updateIn(['type'], () => type).setIn(['payload'], Map(payload));
  }

  return state;
}

export default reducer;
